module.exports = __webpack_public_path__ + "img/cards.ade31177.png";